module.exports = __webpack_public_path__ + "static/portrait-5a80377da7308b7ca1aa8cc44ba978db.png";